<button class="flex justify-center items-center context-menu-icon pl-6"
  [matMenuTriggerFor]="instanceSubmenu" (mouseenter)="trigger.openMenu()" >
  <span class="default-filter fw-400">{{ selectedDefaultFilter.label }}</span>
  <mat-icon svgIcon="expand_more"></mat-icon>
</button>

<mat-menu #instanceSubmenu class="context-menu-dropdown" overlapTrigger="false">
  <div class="dropdown-container" (mouseleave)="trigger.closeMenu()">
    <div>
      <ng-container *ngFor="let option of defaultFilterOptions">
        <div (click)="defaultFilterChanged(option)" class="cursor-pointer options pl-16 pr-16 pt-12 pb-12"
          [ngClass]="{'active': option.label === selectedDefaultFilter.label}">{{option.label}}
          <mat-icon *ngIf="option.label === selectedDefaultFilter.label" svgIcon="done" class="ml-14"></mat-icon>
        </div>
      </ng-container>
    </div>
  </div>
</mat-menu>